import { _section } from "./_section";

export const _downloadBtn = () => {
    if ((window as any)._downloadBtn) return;
    (window as any)._downloadBtn = _section.getOS();

    let _btns = [
        ...document.querySelectorAll("[data-download-ios]"),
        ...document.querySelectorAll("[data-download-android]"),
        ...document.querySelectorAll("[data-download-huawei]"),
    ];

    _btns = _btns.filter((item, index, self) => self.indexOf(item) === index);

    _btns.forEach((item) => {
        const _item = item as HTMLElement;

        const _ios = _item.dataset.downloadIos;
        const _android = _item.dataset.downloadAndroid;
        const _huawei = _item.dataset.downloadHuawei;

        if (_ios && (window._downloadBtn === "ios" || window._downloadBtn === "macos"))
            _item.setAttribute("href", _ios);

        if (
            _android &&
            (window._downloadBtn === "android" ||
                window._downloadBtn === "windows" ||
                window._downloadBtn === "unix" ||
                window._downloadBtn === "linux")
        )
            _item.setAttribute("href", _android);

        if (_huawei && window._downloadBtn === "huawei") _item.setAttribute("href", _huawei);
    });
};
